/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import AdminTableContent from "./components/adminTableContent";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  Menu,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

// import { StyledOutlineButton } from "../vendorRegistration/components/StepMain";

import { useDispatch, useSelector } from "react-redux";
import {
  ApprovedVendorDownloadThunk,
  DomesticVendorDownloadThunk,
  InternationalVendorDownloadThunk,
  resetApprovedVendorBuffer,
  resetDomesticVendorBuffer,
  resetInternationalVendorBuffer,
  vendor_reg_uplaod_excel,
} from "./redux/adminTableSlice";
import { history } from "../../app/history";
import LocalStorage from "../../utilities/localStorage";
import {
  Search,
  GetAppRounded,
  UploadRounded,
  KeyboardArrowDown,
} from "@mui/icons-material";
// import vendor_excel from "../../assets/Vendors.xlsx";
import domestic_vendor_excel from "../../assets/domestic_vendor.xlsx";
import international_vendor_excel from "../../assets/international_vendor.xlsx";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { useEffect } from "react";
// import { Link } from "react-router-dom";

function AdminTable() {
  const [loading, setLoading] = React.useState(false);
  const [fileOpen, setFileOpen] = React.useState(false);
  const [search, setSearch] = React.useState();
  const [clicked, setClicked] = React.useState(false);
  const [filter, setFilter] = React.useState(1);
  const [data, setData] = React.useState("");
  const [searchFilter, setSearchFilter] = React.useState("");
  const {
    approvedVendorBuffer,
    domesticVendorBuffer,
    internationalVendorBuffer,
    downloadLoading,
  } = useSelector((state) => state.pendinglist);
  const userData = LocalStorage.getItem("tata_login_user");
  const clientId = LocalStorage.getItem("client")?.id;
  const dispatch = useDispatch();
  const handleClose = () => {
    setFileOpen(false);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };
  const handleSearchFilterChange = (event) => {
    setSearchFilter(event.target.value);
  };

  // Effect to handle download
  useEffect(() => {
    if (approvedVendorBuffer) {
      try {
        const url = window.URL.createObjectURL(
          new Blob([approvedVendorBuffer])
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "output.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        // Clear the buffer after the download
        dispatch(resetApprovedVendorBuffer());
      } catch (error) {
        console.error("Error downloading file: ", error);
      }
    }
  }, [approvedVendorBuffer, dispatch]);

  // Effect to handle domestic download
  useEffect(() => {
    if (domesticVendorBuffer) {
      try {
        const url = window.URL.createObjectURL(
          new Blob([domesticVendorBuffer])
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "domestic-vendor-format.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        // Clear the buffer after the download
        dispatch(resetDomesticVendorBuffer());
      } catch (error) {
        console.error("Error downloading file: ", error);
      }
    }
  }, [domesticVendorBuffer, dispatch]);

  // Effect to handle international download
  useEffect(() => {
    if (internationalVendorBuffer) {
      try {
        const url = window.URL.createObjectURL(
          new Blob([internationalVendorBuffer])
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "international-vendor-format.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        // Clear the buffer after the download
        dispatch(resetInternationalVendorBuffer());
      } catch (error) {
        console.error("Error downloading file: ", error);
      }
    }
  }, [internationalVendorBuffer, dispatch]);

  const handleDownload = () => {
    dispatch(ApprovedVendorDownloadThunk());
  };
  const handleDomesticDownload = () => {
    dispatch(DomesticVendorDownloadThunk());
  };
  const handleInternationalDownload = () => {
    dispatch(InternationalVendorDownloadThunk());
  };

  // const handleUpload = () => {
  //   setLoading(true);
  //   var formData = new FormData();
  //   formData.append("file", data);
  //   dispatch(vendor_reg_uplaod_excel(formData)).then((response) => {
  //     if (response?.payload?.success) {
  //       setLoading(false);
  //       setFileOpen(false);
  //       history.push("/app/recomm-vcc");
  //     }
  //     setLoading(false);
  //     setFileOpen(false);
  //   });
  //   setLoading(false);
  // };
  const handleUpload = () => {
    if (!data) {
      alert("Please select a file");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", data);

    dispatch(vendor_reg_uplaod_excel(formData))
      .then(async (response) => {
        const blob = response.payload;
        console.log("response :", response);
        console.log("response.payload :", response.payload);
        console.log("blob :", blob);

        if (!blob) {
          alert("No response from server");
          return;
        }

        // Case 1: Check if it's a Blob (Excel error file)
        if (
          blob instanceof Blob &&
          blob.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "unregistered_vendors.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();

          alert("Some vendors were not registered. Downloaded details.");
          window.location.href = "/app/recomm-vcc";
        } // Case 2: Not a Blob (likely JSON)
        else if (typeof blob === "object" && blob.success !== undefined) {
          // if (blob.success) {
          //   alert(blob.message || "Vendors uploaded successfully!");
          // } else {
          //   alert(blob.message || "Some vendors could not be uploaded.");
          // }

          window.location.href = "/app/recomm-vcc";
        }
        // Case 3: Unexpected response
        else {
          alert("Unexpected server response.");
        }
      })
      .catch((error) => {
        console.error("Upload error:", error);
        alert("Upload failed due to network or server error.");
      })
      .finally(() => {
        setLoading(false);
        setFileOpen(false);
      });
  };
  return (
    <div>
      <TitleHolder style={{ paddingBottom: "5px" }}>
        <Grid container spacing={2}>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Vendors
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "end",
              gap: "0.5rem",
            }}
            xs={6}
          >
            <Grid
              item
              sx={{ display: "flex", gap: "1rem", alignItems: "center" }}
            >
              {clientId === 2 && (
                <FormControl variant="standard" size="small">
                  <InputLabel>Filter</InputLabel>
                  <Select
                    value={filter}
                    onChange={handleFilterChange}
                    label="Filter"
                    // size="small"
                    sx={{ width: "75px" }}
                  >
                    <MenuItem value="1">All</MenuItem>
                    <MenuItem value="2">Push</MenuItem>
                    <MenuItem value="3">Not Push</MenuItem>
                  </Select>
                </FormControl>
              )}
              <FormControl variant="outlined" size="small">
                <InputLabel>Filter</InputLabel>
                <Select
                  value={searchFilter}
                  onChange={handleSearchFilterChange}
                  label="Filter"
                  sx={{ width: "200px" }}
                >
                  <MenuItem value="company_name">Company Name</MenuItem>
                  <MenuItem value="company_email">Company Email</MenuItem>
                  <MenuItem value="permanent_account_number">
                    Permanent Account Number
                  </MenuItem>
                  <MenuItem value="vendor_code">Vendor Code</MenuItem>
                </Select>
              </FormControl>
              <TextField
                variant="outlined"
                size="small"
                label="Search field"
                onChange={(e) => setSearch(e.target.value)}
              />
              <Button
                variant="contained"
                size="large"
                onClick={() => setClicked(true)}
              >
                <Search />
              </Button>
            </Grid>
            {userData.roles[0] === "super admin" ? (
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Button
                      variant="contained"
                      sx={{
                        fontSize: "2rem",
                        height: "2.5rem",
                        width: "4.3rem",
                      }}
                      {...bindTrigger(popupState)}
                    >
                      <KeyboardArrowDown />
                    </Button>
                    <Menu {...bindMenu(popupState)}>
                      <MenuItem onClick={handleDomesticDownload}>
                        <span
                          style={{
                            fontSize: "0.8rem",
                          }}
                        >
                          {<GetAppRounded color="primary" />}Download Domestic
                          Excel Format
                        </span>
                      </MenuItem>
                      <MenuItem onClick={handleInternationalDownload}>
                        <span
                          style={{
                            fontSize: "0.8rem",
                          }}
                        >
                          {<GetAppRounded color="primary" />}Download Int'l
                          Excel Format
                        </span>
                      </MenuItem>
                      <MenuItem onClick={() => setFileOpen(true)}>
                        <span
                          style={{
                            fontSize: "0.8rem",
                          }}
                        >
                          {<UploadRounded color="primary" />} Upload Vendor
                          Excel
                        </span>
                      </MenuItem>
                      <MenuItem onClick={handleDownload}>
                        <span
                          style={{
                            fontSize: "0.8rem",
                          }}
                        >
                          {<GetAppRounded color="primary" />} Download Approved
                          Vendors
                        </span>
                      </MenuItem>
                    </Menu>
                  </React.Fragment>
                )}
              </PopupState>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </TitleHolder>

      <StepperContentHolder style={{ paddingTop: "5px" }}>
        <AdminTableContent
          search={search}
          clicked={clicked}
          setClicked={setClicked}
          column={searchFilter}
          filter={filter}
        />
      </StepperContentHolder>

      {/* add file dialog */}
      <Dialog open={fileOpen} aria-labelledby="draggable-dialog-title">
        <DialogTitle
          style={{ cursor: "move", fontWeight: "Bold" }}
          id="draggable-dialog-title"
        >
          Add Excel File
        </DialogTitle>

        <DialogContent>
          <DialogContentText>Add an excel file to upload</DialogContentText>

          <DialogContentText>
            <input
              type="file"
              fullWidth
              accept=".xlsx .xls .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              onChange={(e) => setData(e.target.files[0])}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ alignItems: "right" }}>
          <Button
            autoFocus
            onClick={(() => setData(""), handleClose)}
            style={{ border: "#4059e5 solid 1px", height: "30px" }}
          >
            Cancel
          </Button>
          <LoadingButton
            sx={{
              textTransform: "none",
              background: "#4059e5",
              width: "70px",
              height: "30px",
            }}
            color="primary"
            variant="contained"
            onClick={handleUpload}
            loading={loading}
            loadingPosition="start"
          >
            Upload
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1, display: "flex", flexDirection: "column", gap: 2 }}
        open={downloadLoading}
      >
        <CircularProgress color="inherit" />
        <span style={{ fontFamily: "var(--font-family-reg)", fontSize: "16px" }}>Downloading Approved Vendors list, please wait...</span>
      </Backdrop>
    </div>
  );
}

export default AdminTable;
